import React from 'react';
import { connect } from 'react-redux';
import LabelledValue from 'src/components/labelledValue/LabelledValue';
import { Page, Panel, Stack } from 'src/components/matchbox';
import { useAuthentication } from 'src/context/AuthenticationContext';
import { hasAccountOptionEnabled } from 'src/helpers/conditions/account';
import { getCurrentAccountPlan } from 'src/selectors/accessConditionState';
import CancellationPanel from './components/CancellationPanel';
import EnforceTfaPanel from './components/EnforceTfaPanel';
import SingleSignOnPanel from './components/SingleSignOnPanel';
import UIOptionsPanel from './components/UIOptionsPanel';

export function AccountSettingsPage({ currentUser, tfaRequiredEnforced, isFreePlan }) {
  const {
    context: { isAuth0User }
  } = useAuthentication();

  return (
    <Page title="Account Settings">
      <Stack>
        <Panel.LEGACY sectioned>
          <LabelledValue label="Account ID">{currentUser.customer}</LabelledValue>
        </Panel.LEGACY>
        {!tfaRequiredEnforced && <SingleSignOnPanel />}
        {!isAuth0User && !isFreePlan && <EnforceTfaPanel />}
        <UIOptionsPanel />
        <CancellationPanel />
      </Stack>
    </Page>
  );
}

const mapStateToProps = (state) => {
  const currentPlan = getCurrentAccountPlan(state);
  return {
    currentUser: state.currentUser,
    tfaRequiredEnforced: hasAccountOptionEnabled('enforce_tfa_required')(state),
    isFreePlan: currentPlan.isFree
  };
};

export default connect(mapStateToProps)(AccountSettingsPage);
